import React from "react";

import { IconName } from "../types";
import Icon from "./Icon";

const Checkbox = (props: {
  checked: boolean;
  disabled?: boolean;
  children: JSX.Element;
  onChange: (value: boolean) => void;
}) => {
  const onKeyPress = (e: React.KeyboardEvent) => {
    // When user has the checkbox focused and presses space (e.g. for accessibility).
    if (e.key === " " && !props.disabled) {
      e.preventDefault();
      e.stopPropagation();
      props.onChange(!props.checked);
    }
  };
  return (
    <div
      className={`pyht-checkbox ${props.checked ? "checked" : ""}  ${
        props.disabled ? "disabled" : ""
      }`}
      onClick={() => !props.disabled && props.onChange(!props.checked)}
      role="checkbox"
      aria-checked={props.checked}
      aria-disabled={props.disabled}
      tabIndex={0}
      onKeyPress={onKeyPress}
    >
      <div className={"checkbox-icon"}>
        <Icon name={IconName.CHECK_MARK} />
      </div>
      <div className={"checkbox-label"}>{props.children}</div>
    </div>
  );
};

export default Checkbox;
